import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  DialogContentText,
  DialogTitle,
  Button
} from "@material-ui/core";
import { primaryShade1, white, black } from "../styles/color";
function Transition(props) {
  return <Slide direction="up" {...props} />;
}
class NoInvoicePrintDataDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      openNoInvoicePrintDataDialog,
      handleInvoicePrintDataDialogClose,
      handleInvoicePrintDataRedirect
    } = this.props;
    return (
      <div>
        <Dialog
          open={openNoInvoicePrintDataDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleInvoicePrintDataDialogClose}
          onBackdropClick={handleInvoicePrintDataDialogClose}
        >
          <DialogTitle
            id="alert-dialog-slide-title"
            style={{
              textDecorationolor: white,
              marginBottom: "5px"
            }}
          >
            {"Incomplete Data !"}
          </DialogTitle>

          <DialogContent>
            <DialogContentText
              id="alert-dialog-slide-description"
              style={{ color: black }}
            >
              All Details for Invoice Print Not Added Yet! Please Fill Details
              In Setting's Manage Invoice Print Details. Click on "Add Here" to
              add Invoice Print Data.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={handleInvoicePrintDataRedirect}
              style={{
                backgroundColor: primaryShade1,
                color: white
              }}
            >
              Add Here
            </Button>
            <Button
              variant="outlined"
              onClick={handleInvoicePrintDataDialogClose}
              style={{
                backgroundColor: primaryShade1,
                color: white
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default NoInvoicePrintDataDialog;
